export default "__VITE_ASSET__BECXWwNY__"